import { ErrorHandler, isDevMode, Injectable } from '@angular/core';

declare var newrelic: any;

@Injectable()
export class NewRelicErrorHandler implements ErrorHandler {
  handleError(error: TypeError) {
    console.error(error);
    newrelic.noticeError(error);
  }
}